<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Antrian" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <center class="py-3">
            <h3 class="mb-4">Antrian Saat Ini</h3>
          </center>
          <div v-if="loaded">
            <div class="row">
              <div class="col-md-4 px-5">
                <div class="queue-container">
                  <div class="card p-3">
                    <span :class="'badge mr-3 mb-3 badge-primary'">Umum</span>
                    <LoadingSpin v-if="counting == 1" />
                    <div v-else>
                      <div
                        v-if="
                          queue &&
                            queue['DIPROSES'] &&
                            queue['DIPROSES'].Umum &&
                            queue['DIPROSES'].Umum.length
                        "
                      >
                        <h1 :class="'mb-2 text-primary'">
                          {{ queue["DIPROSES"].Umum[0].nomor }}
                        </h1>
                        <h4 class="font-body">
                          Ke {{ queue["DIPROSES"].Umum[0].tempat_proses }}
                        </h4>
                      </div>
                      <div v-else>
                        <h1 :class="'mb-2 text-primary'">Belum</h1>
                        <h4 class="font-body">ada antrian</h4>
                      </div>
                    </div>
                  </div>
                  <button
                    :class="'btn btn-lg btn-icon btn-primary'"
                    @click="() => counterNext(1)"
                  >
                    <i class="material-symbols-outlined">add</i>
                  </button>
                </div>
                <button
                  class="btn btn-circle btn-outline-primary btn-icon mt-3"
                  @click="() => displayList('Umum')"
                >
                  <i class="material-symbols-outlined">mic</i>
                </button>

                <div
                  v-if="
                    queue &&
                      queue['MENUNGGU'] &&
                      queue['MENUNGGU'].Umum &&
                      queue['MENUNGGU'].Umum.length
                  "
                >
                  <h5 class="my-3 font-body">Selanjutnya</h5>
                  <h3
                    v-for="(item, index) in queue['MENUNGGU'].Umum"
                    v-bind:key="item.id + Math.random(1024)"
                    :class="index ? 'p-left text-muted' : 'next-turn text-info'"
                  >
                    <i v-if="!index" class="material-symbols-outlined"
                      >chevron_right</i
                    >
                    {{ item.nomor }}
                  </h3>
                </div>
              </div>

              <div class="col-md-4 px-5">
                <div class="queue-container">
                  <div class="card p-3">
                    <span :class="'badge mr-3 mb-3 badge-secondary'">BPJS</span>
                    <LoadingSpin v-if="counting == 2" />
                    <div v-else>
                      <div
                        v-if="
                          queue &&
                            queue['DIPROSES'] &&
                            queue['DIPROSES'].BPJS &&
                            queue['DIPROSES'].BPJS.length
                        "
                      >
                        <h1 :class="'mb-2 text-secondary'">
                          {{ queue["DIPROSES"].BPJS[0].nomor }}
                        </h1>
                        <h4 class="font-body">
                          Ke {{ queue["DIPROSES"].BPJS[0].tempat_proses }}
                        </h4>
                      </div>
                      <div v-else>
                        <h1 :class="'mb-2 text-secondary'">Belum</h1>
                        <h4 class="font-body">ada antrian</h4>
                      </div>
                    </div>
                  </div>

                  <button
                    :class="'btn btn-lg btn-icon btn-secondary'"
                    @click="() => counterNext(2)"
                  >
                    <i class="material-symbols-outlined">add</i>
                  </button>
                </div>
                <button
                  class="btn btn-circle btn-outline-secondary btn-icon mt-3"
                  @click="() => displayList('BPJS')"
                >
                  <i class="material-symbols-outlined">mic</i>
                </button>
                <div
                  v-if="
                    queue &&
                      queue['MENUNGGU'] &&
                      queue['MENUNGGU'].BPJS &&
                      queue['MENUNGGU'].BPJS.length
                  "
                >
                  <h5 class="my-3 font-body">Selanjutnya</h5>
                  <h3
                    v-for="(item, index) in queue['MENUNGGU'].BPJS"
                    v-bind:key="item.id + Math.random(1024)"
                    :class="index ? 'p-left text-muted' : 'next-turn text-info'"
                  >
                    <i v-if="!index" class="material-symbols-outlined"
                      >chevron_right</i
                    >
                    {{ item.nomor }}
                  </h3>
                </div>
              </div>

              <div class="col-md-4 px-5">
                <div class="queue-container">
                  <div class="card p-3">
                    <span :class="'badge mr-3 mb-3 badge-warning'"
                      >Asuransi Lain</span
                    >
                    <LoadingSpin v-if="counting == 3" />
                    <div v-else>
                      <div
                        v-if="
                          queue &&
                            queue['DIPROSES'] &&
                            queue['DIPROSES']['Asuransi'] &&
                            queue['DIPROSES']['Asuransi'].length
                        "
                      >
                        <h1 :class="'mb-2 text-warning'">
                          {{ queue["DIPROSES"]["Asuransi"][0].nomor }}
                        </h1>
                        <h4 class="font-body">
                          Ke
                          {{ queue["DIPROSES"]["Asuransi"][0].tempat_proses }}
                        </h4>
                      </div>
                      <div v-else>
                        <h1 :class="'mb-2 text-warning'">Belum</h1>
                        <h4 class="font-body">ada antrian</h4>
                      </div>
                    </div>
                  </div>
                  <button
                    :class="'btn btn-lg btn-icon btn-warning'"
                    @click="() => counterNext(3)"
                  >
                    <i class="material-symbols-outlined">add</i>
                  </button>
                </div>
                <button
                  class="btn btn-circle btn-outline-warning btn-icon mt-3"
                  @click="() => displayList('Asuransi')"
                >
                  <i class="material-symbols-outlined">mic</i>
                </button>
                <div
                  v-if="
                    queue &&
                      queue['MENUNGGU'] &&
                      queue['MENUNGGU']['Asuransi'] &&
                      queue['MENUNGGU']['Asuransi'].length
                  "
                >
                  <h5 class="my-3 font-body">Selanjutnya</h5>
                  <h3
                    v-for="(item, index) in queue['MENUNGGU']['Asuransi']"
                    v-bind:key="item.id + Math.random(1024)"
                    :class="index ? 'p-left text-muted' : 'next-turn text-info'"
                  >
                    <i v-if="!index" class="material-symbols-outlined"
                      >chevron_right</i
                    >
                    {{ item.nomor }}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <Loading v-else></Loading>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.counter {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  border: 10px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
}
.next-turn {
  align-items: center;
  display: flex;
}
.p-left {
  padding-left: 2rem;
}
h3 > i {
  font-size: 2rem;
}
.queue-container {
  display: flex;
  width: 100%;
}
.queue-container .card {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  flex: 3;
}
.queue-container button {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  flex: 1;
}
</style>
<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import Loading from "@/components/Loading.vue";
import LoadingSpin from "@/components/LoadingSpin.vue";
import { patientTypes } from "@/store/index.js";
// import { HTTP } from "@/config.js";
let counter = 30;
let paymentClasses = {
  U: "primary",
  B: "secondary",
  A: "warning",
};
const adm = 5;
// let queue = [
//   {
//     type:'UMUM',
//     label:'U',
//     adm:1,
//     current:134
//   },
//   {
//     type:'BPJS',
//     label:'B',
//     adm:3,
//     current:54
//   },
//   {
//     type:'ASURANSI',
//     label:'A',
//     adm:2,
//     current:14
//   }
// ]

export default {
  name: "Antrian",
  components: {
    Navbar,
    Sidebar,
    Loading,
    LoadingSpin,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      loaded: false,
      counting: 0,
      errors: [],
      counter: counter,
      queue: null,
      adm: adm,
      paymentClasses: paymentClasses,
      synth: window.speechSynthesis,
      voiceList: [],
      greetingSpeech: new window.SpeechSynthesisUtterance(),
    };
  },
  methods: {
    initDisplay: async function(repeatCall) {
      if (!repeatCall) {
        this.loaded = false;
      }
      let self = this;
      try {
        let result = await self.$store.state.HTTP.get(`antrian`);
        //console.log(result);
        if (result.status == "200") {
          if (!self.queue) {
            self.queue = result.data;
          }
          if (self.queue) {
            if (
              self.queue["DIPROSES"]["Umum"][0] !=
                result.data["DIPROSES"]["Umum"][0] ||
              self.queue["DIPROSES"]["BPJS"][0] !=
                result.data["DIPROSES"]["BPJS"][0] ||
              self.queue["DIPROSES"]["Asuransi"][0] !=
                result.data["DIPROSES"]["Asuransi"][0]
            ) {
              self.queue = result.data;
            }
          }
          if (!repeatCall) {
            let queue = self.queue["DIPROSES"]["Umum"][0];
            if (queue) {
              let queueNumber = queue.nomor;
              let place = queue.tempat_proses;
              self.callPatient("Umum", queueNumber, place);
            }
            setTimeout(function() {
              let queue = self.queue["DIPROSES"]["BPJS"][0];
              if (queue) {
                let queueNumber = queue.nomor;
                let place = queue.tempat_proses;
                if (!repeatCall) {
                  self.callPatient("BPJS", queueNumber, place);
                }
              }
              setTimeout(function() {
                let queue = self.queue["DIPROSES"]["Asuransi"][0];
                if (queue) {
                  let queueNumber = queue.nomor;
                  let place = queue.tempat_proses;
                  if (!repeatCall) {
                    self.callPatient("Asuransi", queueNumber, place);
                  }
                }
              }, 10000);
            }, 10000);
          }
          //console.log(self.queue);
        } else {
          self.errors.push(result.status);
        }
        self.counting = 0;
        self.loaded = true;
      } catch (e) {
        //console.log(e);
        self.errors.push(e);
      }
    },
    displayList: async function(type) {
      try {
        let result = await this.$store.state.HTTP.get(`antrian`);
        //console.log(result);
        //console.log(type);
        if (result.status == "200") {
          this.queue = result.data;
          //console.log(this.queue);
          let queue = this.queue["DIPROSES"][type][0];
          if (queue) {
            let queueNumber = queue.nomor;
            let place = queue.tempat_proses;
            this.callPatient(type, queueNumber, place);
          }
        } else {
          this.errors.push(result.status);
        }
        this.counting = 0;
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    counterNext: async function(id_asuransi) {
      try {
        this.counting = id_asuransi;
        let result = await this.$store.state.HTTP.get(
          `antrian/proses?id_asuransi=${id_asuransi}`
        );
        //console.log(result);
        if (result.status == "200") {
          // this.queue=result.data;
          await this.displayList(patientTypes[id_asuransi]);
          // this.$nextTick(()=>{if(this.$refs.focusMe){ this.$refs.focusMe.focus()}});
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }

      // this.queue=this.queue.map((item)=>{
      //   if(item.label==label){
      //     item.current+=1;
      //     item.adm=adm;
      //   }
      //   return item;
      // });
    },
    callPatient: async function(type, queueNumber, place) {
      this.greetingSpeech.text = `Pasien ${type} dengan Nomor Antrian ${queueNumber}. Silakan menuju ke loket pendaftaran ${place}.`;
      // //console.log(this.voiceList);
      //   56 adalah bahasa indonesia
      //   6 adalah bahasa indonesia
      //   41 adalah bahasa inggris
      //   versi lain:
      //   11 adalah bahasa indonesia
      this.greetingSpeech.voice = this.voiceList[11];
      this.synth.speak(this.greetingSpeech);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.voiceList = this.synth.getVoices();
    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices();
    };
    this.initDisplay();
    let self = this;
    let counter = 0;
    setInterval(async function() {
      await self.initDisplay(true);
      counter++;
      //console.log('masuk sini '+counter);
    }, 3000);
  },
};
</script>
